import { render, staticRenderFns } from "./NoWalletPopup.vue?vue&type=template&id=bf9985c4&"
import script from "./NoWalletPopup.vue?vue&type=script&lang=js&"
export * from "./NoWalletPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports